import type { TGetSimulacoesRelacionadas } from '@/features/simulacao/interfaces/simulacao.type'
import { HttpService } from '@/shared/lib/http'

export class GetSimulacoesRelacionadas extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TGetSimulacoesRelacionadas>(`/api/v2/Simulacao/${simulacaoId}/relacionadas`)
  }
}
